// src/resources/rdf/ValidateWithTermsButton.js
import * as React from "react";
import { useRecordContext } from "react-admin";
import { Button, Tooltip } from "@mui/material";
import DoneAllIcon from "@mui/icons-material/DoneAll";
import CircularProgress from "@mui/material/CircularProgress";
import { adminPatch } from "../../config/api";
import useModerationAction from "../../hooks/useModerationAction";

const isValidated = (status) => status === "VALIDATED";

const needsSubjectValidation = (record) => {
    if (!record) return false;
    return record.subjectUsesVariant
        ? !isValidated(record.subjectVariantStatus)
        : !isValidated(record.subjectStatus);
};

const needsOobjectValidation = (record) => {
    if (!record) return false;
    return record.oobjectUsesVariant
        ? !isValidated(record.oobjectVariantStatus)
        : !isValidated(record.oobjectStatus);
};

const shouldDisplay = (record) => {
    if (!record) return false;
    return record.status !== "VALIDATED"
        || needsSubjectValidation(record)
        || needsOobjectValidation(record);
};

export default function ValidateWithTermsButton() {
    const record = useRecordContext();
    const { loading, run } = useModerationAction();

    if (!shouldDisplay(record)) {
        return null;
    }

    const onClick = async (event) => {
        event?.stopPropagation?.();
        await run({
            id: record.id,
            request: () => adminPatch(`/rdf/${record.id}/validate-with-terms`),
            successMessage: "RDF et termes validés",
        });
    };

    return (
        <Tooltip title="Valider le RDF et ses termes">
            <span>
                <Button
                    onClick={onClick}
                    disabled={loading}
                    variant="contained"
                    aria-label="Valider RDF et termes"
                    sx={{
                        bgcolor: "#1976d2",
                        color: "white",
                        borderRadius: "20px",
                        textTransform: "none",
                        px: 2,
                        py: 0.5,
                        fontWeight: "bold",
                        ml: 1,
                        "&:hover": { bgcolor: "#1259a8" },
                    }}
                    startIcon={
                        loading ? (
                            <CircularProgress size={16} sx={{ color: "white" }} />
                        ) : (
                            <DoneAllIcon />
                        )
                    }
                >
                    Tout valider
                </Button>
            </span>
        </Tooltip>
    );
}
